import React from "react";
import Icons from "../assets/icons";

export default function Loader() {
  return (
    <div className="flex justify-center items-center">{Icons.ic_loading}</div>
  );
}
